import { LoaderFunctionArgs } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import { paymentGeoLoader } from './paymentGeoLoader'
import { store } from '../app/store'
import { lazyRoute } from '../utils/lazyRoute'

function getStripeAllowedRoles(): string[] {
  const userInfo = store.getState().auth.userInfo
  return userInfo?.vendor === 'Stripe' ? ['Holder'] : []
}

const paymentRoutes = [
  {
    path: '/payment-blocked',
    lazy: lazyRoute(() => import('../pages/Portal/Payment/PaymentBlocked')),
  },
  {
    path: '/pay',
    lazy: lazyRoute(() => import('../pages/Portal/Payment')),
    loader: paymentGeoLoader,
  },
  {
    path: '/payment',
    lazy: lazyRoute(() => import('../pages/Portal/Payment')),
    loader: paymentGeoLoader,
  },
  {
    path: '/payment/success',
    lazy: lazyRoute(() => import('../pages/Portal/Payment/PaymentSuccess')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, { authOnly: true }),
  },
  {
    path: '/my-subscriptions',
    lazy: lazyRoute(
      () => import('../pages/Portal/MySubscriptions'),
      'MySubscriptions',
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: getStripeAllowedRoles(),
      }),
  },
  {
    path: '/payment-methods',
    lazy: lazyRoute(
      () => import('../pages/Portal/PaymentMethods'),
      'PaymentMethods',
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: getStripeAllowedRoles(),
      }),
  },
  {
    path: '/payment-history',
    lazy: lazyRoute(() => import('../pages/Portal/PaymentHistory')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: getStripeAllowedRoles(),
      }),
  },
  {
    path: '/change-plan/:id/:plan',
    lazy: lazyRoute(
      () => import('../pages/Portal/MySubscriptions/ChangePlan'),
      'ChangePlan',
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: getStripeAllowedRoles(),
      }),
  },
]

export default paymentRoutes
